import { Fragment } from 'react'
import PropTypes from 'prop-types'
import Typography from 'beam/dist/Typography'
import { CircularProgress } from 'beam/dist/Progress'
import withStyles from 'beam/dist/styles/index'
import { withTranslation } from 'react-i18next'

import SpeechHitsGraph from './SpeechHitsGraph'

const styles = () => ({
  rootNoData: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
  },
})

const SpeechHitsContent = props => {
  const { t, classes, loading, error } = props
  const renderLoading = () => {
    return (
      <div className={classes.rootNoData}>
        <CircularProgress />
      </div>
    )
  }

  const renderError = () => {
    return (
      <div className={classes.rootNoData}>
        <Typography color="secondary" align="center">
          {t('error')}
        </Typography>
        <Typography color="secondary" align="center">
          {t('speechHitsDataError')}
        </Typography>
      </div>
    )
  }

  const renderData = () => {
    //This filters out `classes`, `events` and `t` so that they are not passed to SpeechHitsGraph
    // eslint-disable-next-line no-unused-vars -- TODO: remove this eslint-disable or replace this eslint-disable comment with a proper justification
    const { speechHits, zoomed, selectedCategory, allCategory, classes, t, ...speechHitsProps } = props
    const filteredSpeechHits = speechHits.filter(
      hit => hit.category === selectedCategory || selectedCategory === allCategory,
    )
    return <SpeechHitsGraph showEvents={true} zoomed={zoomed} speechHits={filteredSpeechHits} {...speechHitsProps} />
  }

  return (
    <Fragment>
      {(loading && renderLoading()) || (error && renderError()) || (!loading && !error && renderData())}
    </Fragment>
  )
}

SpeechHitsContent.displayName = 'SpeechHitsContent'

SpeechHitsContent.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  speechHits: PropTypes.array,
  selectedCategory: PropTypes.string,
  allCategory: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  zoomed: PropTypes.bool,
}

SpeechHitsContent.defaultProps = {
  zoomed: true,
}

export { SpeechHitsContent as UnstyledSpeechHitsContent }

export default withTranslation()(withStyles(styles)(SpeechHitsContent))
